import { DustAppPageLayout } from "@dust-tt/front/components/apps/DustAppPageLayout";
import { Outlet } from "react-router-dom";

export function AppsRouterLayout() {
  return (
    <DustAppPageLayout>
      <Outlet />
    </DustAppPageLayout>
  );
}
